import React from "react";

// Components
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";

function Reports() {
  // ดึงข้อมูล company จาก localStorage
  let compId = 1; // ค่าเริ่มต้น
  const companyData = localStorage.getItem("company");
  if (companyData) {
    try {
      const parsedData = JSON.parse(companyData);
      compId = parsedData.id || parsedData.compId || 1; // ปรับตามโครงสร้างข้อมูลจริง
    } catch (error) {
      console.error("Error parsing company data:", error);
      compId = 1; // ใช้ค่าเริ่มต้นหากเกิดข้อผิดพลาด
    }
  }

  return (
    <div className="Reports">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container-fluid">
            <div className="page-inner py-4">
              {/* Page Header */}
              <div className="d-flex align-items-center justify-content-between mb-4">
                <Breadcrumbs page="Reports" items={[]} />
              </div>

              {/* Cards Section */}
              <div className="row row-cols-1 row-cols-md-2 row-cols-lg-2 g-4">
                {/* Card Template */}
                {[
                  {
                    title: "1. รายงานยอดซื้อ / ขายประจำวัน",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/sales-report",
                  },
                  {
                    title: "3. รายงานยืมลังประจำวัน",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/loan-crate-report",
                    showOnlyForCompId: [Number(localStorage.getItem("company") === "2")],
                  },
                  {
                    title: "4. รายงานมัดจำประจำวัน",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/deposit-report",
                  },
                  {
                    title: "5. รายงานลูกค้ายืมลัง แล้วไม่สั่งเกินสัปดาห์",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/overdue-loan-crate-report",
                    showOnlyForCompId: [Number(localStorage.getItem("company") === "2")],
                  },
                  {
                    title: "6. รายงานลูกหนี้ รายวัน",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/receivables-report",
                  },
                  {
                    title: "7. รายงานเจ้าหนี้ รายวัน",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/payables-report",
                  },
                  {
                    title: "8. รายงานนำส่งรายได้",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/vansale-report",
                  },
                  {
                    title: "9 รายงานส่งเงิน",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/money-transfer-report",
                  },
                  {
                    title: "10 รายงานเบิกวัสดุภายใน",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/internal-material-requisition-report",
                  },
                  {
                    title: "11 รายงานวัสดุคงเหลือ",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/material-report",
                  },
                  {
                    title: "12 รายงานวัสดุเคลื่อนไหว",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/material-movement-report",
                  },
                  {
                    title: "13 รายงานใบวางบิล",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/bill-report-new",
                    showOnlyForCompId: [Number(localStorage.getItem("company") === "2")],
                  },
                  {
                    title: "14. รายงานสรุปค่าใช้จ่ายประจำเดือน",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/monthly-expense-summary-report",
                  },
                  {
                    title: "15. รายงานใบวางบิล (บิลค้างรับ ตามลูกค้า - แบบสรุป)",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/bill-report-unpaid-summary",
                    showOnlyForCompId: [Number(localStorage.getItem("company") === "2")],
                  },
                ]
                  .filter((card) => {
                    // หากไม่มี showOnlyForCompId หรือ compId อยู่ใน array ให้แสดง
                    return (
                      !card.showOnlyForCompId ||
                      card.showOnlyForCompId.includes(compId)
                    );
                  })
                  .map((card, index) => (
                    <div className="col" key={index}>
                      <div
                        className="card h-100 border-primary shadow-sm"
                        style={{
                          cursor: "pointer",
                          transition: "transform 0.2s",
                        }}
                        onClick={() => window.location.replace(card.link)}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.transform = "scale(1.05)")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.transform = "scale(1)")
                        }
                      >
                        <div className="card-body d-flex align-items-center">
                          <div
                            className={`me-3 text-center text-white ${card.bgColor} rounded-circle p-4`}
                          >
                            <i className={`${card.icon} fa-2x`}></i>
                          </div>
                          <div>
                            <p className="card-category text-muted mb-1">
                              {card.title}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reports;
